import { useEffect } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import { Button } from '@/components/ui/button';
import { Loader2 } from 'lucide-react';

export default function Login() {
  const { login, isLoading, user, isAuthenticated } = useAuth();
  const { accounts } = useMsal();
  const navigate = useNavigate();

  useEffect(() => {
    // Only redirect after FULL authentication (MSAL + backend validation), so navigation
    // never happens before the backend user call has completed.
    if (accounts.length > 0 && user && isAuthenticated) {
      navigate('/');
    }
  }, [accounts, user, isAuthenticated, navigate]);

  return (
    <div className="flex min-h-screen flex-col bg-background">
      <div className="h-1 w-full bg-success" />
      <main className="flex flex-1 items-center justify-center px-4 py-12">
        <div className="w-full max-w-sm">
          <img src="/deheus-primary-logo.svg" alt="De Heus" className="mx-auto h-16 w-16" />
          <h1 className="mt-6 text-center text-2xl font-semibold tracking-tight">Contract Manager</h1>
          <p className="mt-1 text-center text-sm text-muted-foreground">Sign in with your De Heus Microsoft 365 account.</p>

          <div className="mt-8 rounded-lg border bg-card p-6">
            {isLoading ? (
              <div className="flex items-center justify-center gap-2 py-2 text-sm text-muted-foreground" role="status">
                <Loader2 className="h-4 w-4 animate-spin text-primary" />
                Checking your session…
              </div>
            ) : (
              <>
                <Button onClick={login} className="w-full" size="lg">
                  Sign in with Microsoft
                </Button>
                <p className="mt-4 text-center text-xs text-muted-foreground">Single sign-on with Azure Entra ID</p>
              </>
            )}
          </div>
        </div>
      </main>
      <footer className="border-t-4 border-success bg-footer px-4 py-5 text-center text-xs text-white/60">
        © De Heus {new Date().getFullYear()}
      </footer>
    </div>
  );
}
